import { mapActions, mapGetters } from 'vuex'
import { statusTypes } from '@/mixins'

const deliveryStatusEnum = statusTypes.computed.deliveryStatusEnum()

// Leitura da presença e ações de presença compartilhadas pela seção de Motoboys e pelo
// sidebar de presença.
export default {
  computed: {
    ...mapGetters('pages/sale/deliveryDashboard', ['motoboys', 'isMotoboyOperationPending']),
  },

  methods: {
    ...mapActions('pages/sale/deliveryDashboard', ['setMotoboyPresence']),
    motoboyId(motoboy) {
      return motoboy.motoboyId ?? motoboy.id
    },
    motoboyName(motoboy) {
      return motoboy.name || motoboy.motoboyName || motoboy.supplier?.name || '-'
    },
    presenceState(motoboy) {
      const state = motoboy.presenceState ?? motoboy.state ?? motoboy.presence?.state ?? 'Absent'
      const normalized = String(state).toLowerCase()
      if (normalized === 'present') return 'Present'
      if (normalized === 'unavailable') return 'Unavailable'
      return 'Absent'
    },
    presenceLabel(motoboy) {
      if (this.presenceState(motoboy) === 'Unavailable' && this.hasDeliveryInRoute(motoboy)) {
        return this.$t('Em entrega')
      }
      return {
        Present: this.$t('Presente'),
        Absent: this.$t('Ausente'),
        Unavailable: this.$t('Indisponível'),
      }[this.presenceState(motoboy)]
    },
    presenceVariant(motoboy) {
      return {
        Present: 'success',
        Absent: 'secondary',
        Unavailable: 'warning',
      }[this.presenceState(motoboy)]
    },
    assignedOrders(motoboy) {
      return motoboy.deliveryOrders || motoboy.assignedOrders || motoboy.orders || []
    },
    // Indisponível sem entrega em rota é um motoboy travado: a loja pode liberá-lo.
    hasDeliveryInRoute(motoboy) {
      return this.assignedOrders(motoboy).some(
        order => typeof order === 'object' && order.deliveryStatus === deliveryStatusEnum.IN_PROGRESS
      )
    },
    isPending(motoboy) {
      return this.isMotoboyOperationPending(this.motoboyId(motoboy))
    },
    async changePresence(motoboy, presenceState) {
      try {
        await this.setMotoboyPresence({
          motoboyId: this.motoboyId(motoboy),
          presenceState,
        })
      } catch (error) {
        this.showError({
          error,
          message: this.$t('A alteração de presença não foi aplicada'),
        })
      }
    },
  },
}
